import { Button, Card, CardActions, CardContent } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom';
import hotelsService from 'services/admin/hotelsService';
import { countriesService } from 'services/countries.service';
import _ from 'lodash'
import { snack } from 'components/Snack/Snack';

export default function HotelShortCard({ hotel, options }) {
    const hideButtons = _.get(options, 'hideButtons')

    const navigate = useNavigate()
    const onDelete = async (item) => {
        try {
            const isConfirmed = window.confirm('Вы точно хотите удалить отель?')

            if (isConfirmed) {
                await hotelsService.delete(item.id);
                snack('Отель успешно удален!')
                navigate('/admin/hotels')
            }
        } catch (ex) {
            console.error('При удаление отеля вышла ошибка:', ex?.message)
        }
    };
    return (
        <div>
            <Card className='p-16'>
                <CardContent>
                    <div className='flex gap-8'>
                        <div style={{ width: 100, borderRadius: '8px', overflow: 'hidden' }}>
                            {hotel.photo ? <img style={{ width: '100%' }} alt='' src={hotel.photo} /> : null}
                        </div>
                        <div className='profile' style={{ flex: 0.7 }}>
                            <h3>{hotel.name}</h3>
                            <div className='m-t-8'>{countriesService.getAll(hotel.country)?.name}</div>
                            <div className='m-t-8'>{hotel.city?.name}</div>
                            <div className='m-t-8'>{hotel.address}</div>
                        </div>
                    </div>
                </CardContent>
                {hideButtons ? <></> : <CardActions className='justify-end'>
                    <Link to={`/admin/hotels/edit/${hotel.id}`}>
                        <Button size="small">Редактировать</Button>
                    </Link>
                    <Link onClick={() => onDelete(hotel)}>
                        <Button size="small">Удалить</Button>
                    </Link>
                </CardActions>}
            </Card>
        </div>
    )
}
